import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { message, Modal } from 'ant-design-vue';
import { h, reactive, Ref } from 'vue';
import { create_view_settings, update_view_settings } from 'liyu-pc-base/api/view-model';
import modalBox from 'liyu-pc-base/components/form-modal/modal-tools';
export interface ViewHook {
  saveView: () => void;
  addView: (view_type: string | null) => void;
}
export interface ViewHookProps {
  currentView: Ref<any>;
  getViewData: () => any;
  isViewChange: Ref<boolean>;
  userid: number;
  view_project__flag: string;
  view_menu__flag: string;
  view_menu__name: string;
  fetchViews: () => void;
  is_auth: boolean;
  t: (key: string) => string;
}

export const useView = (props: ViewHookProps): ViewHook => {
  const {
    currentView,
    getViewData,
    isViewChange,
    userid,
    view_project__flag,
    view_menu__flag,
    view_menu__name,
    fetchViews,
    is_auth,
    t,
  } = props;
  const saveView = () => {
    Modal.confirm({
      title: () => '确定覆盖视图吗？',
      content: '当前视图原有的数据会被覆盖',
      icon: () => h(ExclamationCircleOutlined),
      okText: '确定',
      async onOk() {
        currentView.value.data = getViewData();
        await update_view_settings({
          view_settings_id: currentView.value.id,
          data: currentView.value.data,
        });
        isViewChange.value = false;
        message.success('修改成功');
      },
      onCancel() {},
    });
  };
  const addView = (view_type: string | null) => {
    const tempModal = reactive({
      open: true,
      loading: false,
      title: t('新建视图'),
      form: {
        settings: { labelAlign: 'right', layout: 'vertical', col: [] },
        fields: [
          {
            type: 'input',
            name: 'name',
            label: t('视图名称'),
            disabled: false,
            allowClear: true,
            inputType: 'text',
            defaultValue: '',
            placeholder: t('请输入视图名称'),
          },
        ],
        rules: reactive({
          name: [{ required: true, message: t('请输入视图名称') }],
        }),
        model: reactive({ name: '', is_system: [false], view_type: 'personal' }),
      },
      options: {
        view_type: [
          { name: t('个人视图（仅自己可见）'), value: 'personal' },
          { name: t('公共视图（项目成员均可见）'), value: 'public' },
        ],
        is_system: [{ name: t('设为系统视图'), value: true }],
      },
      ok: async (data: any) => {
        const type = view_type || data.view_type || 'personal';
        const res = await create_view_settings({
          user_id: type === 'personal' ? userid : null,
          name: data.name,
          view_project__flag: view_project__flag,
          view_menu__flag: view_menu__flag,
          view_menu__name: view_menu__name,
          is_system: data.is_system && data.is_system[0],
          data: getViewData(),
        });
        await fetchViews();
        currentView.value = res;
        message.success(t('创建成功'));
        isViewChange.value = false;
      },
    });
    if (!view_type) {
      tempModal.form.fields.push({
        type: 'radio',
        name: 'view_type',
        label: t('视图可见范围'),
        disabled: false,
        allowClear: true,
        labelKey: 'name',
        valueKey: 'value',
        defaultValue: '',
        placeholder: '',
      } as any);
    }
    if (is_auth) {
      tempModal.form.fields.push({
        type: 'checkbox',
        name: 'is_system',
        label: '',
        disabled: false,
        allowClear: true,
        labelKey: 'name',
        valueKey: 'value',
        defaultValue: [false],
      } as any);
    }
    modalBox(tempModal);
  };
  return {
    saveView,
    addView,
  };
};
